import { render, staticRenderFns } from "./AdminUpdateTenderDocs.vue?vue&type=template&id=3bf7a510&scoped=true&"
import script from "./AdminUpdateTenderDocs.vue?vue&type=script&lang=js&"
export * from "./AdminUpdateTenderDocs.vue?vue&type=script&lang=js&"
import style0 from "./AdminUpdateTenderDocs.vue?vue&type=style&index=0&id=3bf7a510&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf7a510",
  null
  
)

export default component.exports